import { render, staticRenderFns } from "./NumberInputConfig.vue?vue&type=template&id=21e5b5b6&scoped=true"
import script from "./NumberInputConfig.vue?vue&type=script&lang=js"
export * from "./NumberInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e5b5b6",
  null
  
)

export default component.exports